import React from 'react';
import { FieldErrors } from './FieldErrors';
export const PhoneNumberInput = (props) => {
    const onChange = (event) => {
        props.onChange(event.currentTarget.value);
    };
    return (React.createElement("div", { className: "input-set" },
        React.createElement("label", { htmlFor: props.id },
            props.label,
            props.required ? ' *' : ''),
        React.createElement("input", { type: "tel", id: props.id, value: props.value || '', onChange: onChange, autoComplete: "off" }),
        React.createElement(FieldErrors, { errors: props.errors, name: props.name || props.id })));
};
